import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import SelectTemplate from "./Edit/SelectTemplate";
import TemplateEdit from "./Edit/TemplateEdit";
import DisplayBlocks from "./Display/DisplayBlocks";
import { toast } from "react-toastify";
import Loader from "../../Shared/Loader";

const Reports = () => {
    const [reports, setReports] = useState({ templates: [] });
    const [selectedTemplate, setSelectedTemplate] = useState({});
    const [wip, setWip] = useState(false);
    const [edited, setEdited] = useState([]);

    useEffect(() => {
        getSavedReports();
    }, []);

    const onChange = (template) => {
        const updatedTemplates = reports.templates.map((t) =>
            t.id === template.id ? template : t
        );
        setReports({ ...reports, templates: updatedTemplates });
        setSelectedTemplate(template);
        setWip(true);
        setEdited(
            edited.includes(template.id)
                ? edited
                : edited.concat(template.id)
        );
    };

    const nameExists = (name) => {
        if (reports.templates && reports.templates.length > 0) {
            return reports.templates.some((template) => template.name === name);
        }
        return false;
    };

    const addTemplate = (name) => {
        if (nameExists(name)) {
            toast.error("Ce nom existe déjà");
            return;
        }
        const newTemplate = { name, blocks: [] };
        setReports({
            ...reports,
            templates: reports.templates.concat(newTemplate),
        });
        setWip(true);
        setSelectedTemplate(newTemplate);
    };

    const editTemplateName = (name) => {
        if (nameExists(name)) {
            toast.error("Ce nom existe déjà.");
            return;
        }
        const updatedTemplates = reports.templates.map((template) =>
            template.name === selectedTemplate.name
                ? { ...template, name }
                : template
        );
        setReports({ ...reports, templates: updatedTemplates });
        setWip(true);
        setEdited(
            edited.includes(selectedTemplate.id)
                ? edited
                : edited.concat(selectedTemplate.id)
        );
        setSelectedTemplate(
            updatedTemplates.find(
                (template) => template.id === selectedTemplate.id
            )
        );
    };

    const deleteTemplate = () => {
        const updatedTemplates = reports.templates.filter(
            (template) => template.name !== selectedTemplate.name
        );
        setReports({ ...reports, templates: updatedTemplates });
        setWip(true);
        setSelectedTemplate(
            updatedTemplates.length !== 0 ? updatedTemplates[0] : {}
        );
    };

    const importTemplate = (template) => {
        if (!template.name || template.name === "") {
            toast.error("Document invalide");
            return;
        }
        if (nameExists(template.name)) {
            toast.error("Ce nom existe déjà");
            return;
        }
        setReports({ ...reports, templates: reports.templates.concat(template) });
        setWip(true);
        setSelectedTemplate(template);
    };

    const getSavedReports = async () => {
        try {
            const resp = await axios.get("/orthoptistes/reports");
            if (resp.data.reports !== undefined && resp.data.reports.templates !== undefined) {
                setReports(resp.data.reports);
                setSelectedTemplate(resp.data.reports.templates[0]);
            }
        } catch (err) {
            toast.error("Les comptes rendus n'ont pas pu être récupérés");
        }
    };

    const saveReports = async () => {
        try {
            const resp = await axios.post("/orthoptistes/reports", {
                reports: reports,
                edited,
            });
            setReports(resp.data.reports);
            setSelectedTemplate(
                resp.data.reports.templates.find(
                    (template) => template.name === selectedTemplate.name
                )
            );
            setWip(false);
            setEdited([]);
            toast.success("Les comptes rendus ont été sauvegardés avec succès");
        } catch (err) {
            if (err.response?.status === 400) {
                toast.error("Les titres des contenus éditables doivent être uniques.");
            } else {
                toast.error("Les comptes rendus n'ont pas pu être sauvegardés");
            }
        }
    };

    const focusBlock = useCallback((block) => {
        const element = document.getElementById(`block_${block.id}`);
        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
            });
            element.style.transition = "background-color 1s";
            element.style.backgroundColor = "#e6f7ff";
            setTimeout(() => {
                element.style.backgroundColor = "transparent";
            }, 2000);
        }
    }, []);

    if (!reports) {
        return <Loader />;
    }

    return (
        <div style={{ margin: 0, paddingLeft: 2, display: "flex" }} id="full-height">
            <div
                className="z-depth-1"
                style={{
                    width: "34%",
                    height: "100%",
                    padding: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <SelectTemplate
                    reports={reports}
                    selectedTemplate={selectedTemplate}
                    addTemplate={addTemplate}
                    editTemplateName={editTemplateName}
                    deleteTemplate={deleteTemplate}
                    importTemplate={importTemplate}
                    onChoose={setSelectedTemplate}
                />
                <div
                    style={{
                        backgroundColor: "#fbfbfd",
                        width: "100%",
                        fontStyle: "italic",
                        fontWeight: "bold",
                        boxShadow: "0px 3px 0px 0px rgba(0, 0, 0, 0.10)",
                        marginBottom: "3px",
                    }}
                    className={`center red-text ${wip ? "" : "hide"}`}
                >
                    <h6>
                        Les modifications ne seront pas sauvegardées tant que le
                        bouton SAUVEGARDER n'aura pas été cliqué
                    </h6>
                </div>
                <div
                    style={{
                        backgroundColor: "#fbfbfd",
                        height: "100%",
                        overflowY: "scroll",
                        overflowX: "hidden",
                    }}
                >
                    <TemplateEdit
                        template={selectedTemplate}
                        onChange={onChange}
                    />
                </div>
                <div
                    className="white valign-wrapper"
                    style={{
                        boxShadow: "0px -3px 0px 0px rgba(0, 0, 0, 0.10)",
                        marginTop: "auto",
                        alignSelf: "flex-end",
                        width: "100%",
                    }}
                >
                    <i
                        className="material-icons transparent-text"
                        style={{ paddingLeft: "1vw" }}
                    >
                        egg
                    </i>
                    <div style={{ padding: "2vh 2vw 2vh 2vw", marginLeft: "auto" }}>
                        <a
                            className={`btn-small blue darken-2 waves-light z-depth-0 ${
                                wip ? "" : "disabled"
                            }`}
                            onClick={saveReports}
                        >
                            <i className="material-icons left">save</i>Sauvegarder
                        </a>
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                    paddingTop: "2vh",
                    paddingBottom: "1vh",
                    overflowY: "scroll",
                    width: "66%",
                }}
            >
                <DisplayBlocks
                    template={selectedTemplate}
                    onBlockClick={focusBlock}
                />
            </div>
        </div>
    );
};

export default Reports;
